import { useEffect, useState } from "react";
import AppCard from '../../../../components/appCard.js';

import { Column } from "primereact/column";
import { DataTable } from 'primereact/datatable';

import { format } from "date-fns";
import { toast } from "react-toastify";
import { Api } from "../../../../services/api";
import { DataTablePague, DropdownPague } from '../../../../styles/primeReactConfig.js';

import classNames from "classnames";
import { Button } from "primereact/button";
import { DataView } from "primereact/dataview";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { FaFileExcel, FaPhoneAlt, FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";
import { mask, unmask } from 'remask';

import { useInfo } from "../../../../context/infoContext.js";
import GeraXLSX from "../../../../utils/GeraXLSX.js";

export const NegociadosHigienizados = () => {
    const { viewHigienizadosStatus } = useInfo();

    const [searchValue, setSearchValue] = useState('');
    const [searchType, setSearchType] = useState('documento')
    const [loadTable, setLoadTable] = useState(false);
    const [higienizados, setHigienizados] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);
    const [paginationData, setPaginationData] = useState({
        totalRecords: 0,
        first: 0,
        page: 0,
        rows: 5,
        rowsPerPage: [5, 10, 25, 50]
    })

    useEffect(() => {
        buscaHigienizados();
    }, [paginationData.first, paginationData.rows, paginationData.page])

    // api

    const buscaHigienizados = async () => {
        try {
            setLoadTable(true)
            const { data } = await Api.post(`/higienizacao/info/devedores/${paginationData.rows}/${paginationData.page}`,
                {
                    searchValue: searchType === 'documento' ? unmask(searchValue) : searchValue,
                    searchType
                }
            );

            setHigienizados(data.registros);
            setPaginationData({ ...paginationData, totalRecords: data.total })
        } catch (e) {
            if (e?.response?.status === 404)
                toast.error(e?.response?.data?.message);
            else
                console.error(e)
        } finally {
            setLoadTable(false)
        }
    }

    const downloadXLSX = async () => {
        try {
            setLoadTable(true)
            const { data } = await Api.post(`/higienizacao/info/devedores/${paginationData.totalRecords}/0`,
                {
                    searchValue: searchType === 'documento' ? unmask(searchValue) : searchValue,
                    searchType
                }
            );
            let relatorioXLSX = [];

            for (let registro of data.registros) {
                relatorioXLSX.push({
                    ...registro,
                    data_higienizacao: formatDate(registro.data_higienizacao),
                    devedor_documento: formatDocument(registro.devedor_documento),
                    telefones: mergeArrayString(registro.telefones, 'telefone'),
                    emails: mergeArrayString(registro.emails),
                    enderecos: mergeArrayString(registro.enderecos),
                })
            }

            const headers = [
                'CPF/CNPJ',
                'NOME',
                'SEXO',
                'NASCIMENTO/CRIAÇÃO',
                'DATA HIGIENIZAÇÃO',
                'TELEFONES',
                'E-MAILS',
                'ENDEREÇOS',
            ]
            const fields = [
                'devedor_documento',
                'devedor_nome',
                'devedor_sexo',
                'devedor_nascimento',
                'data_higienizacao',
                'telefones',
                'emails',
                'enderecos',
            ]
            const parametrosXLSX = {
                data: relatorioXLSX,
                headers: headers,
                fields: fields,
                titulo: `Relatorio_Dados_Devedores_${format(new Date(), 'dd-MM-yyyy_HH-mm')}`
            }
            GeraXLSX(parametrosXLSX)
        } catch (e) {
            if (e?.response?.status === 404)
                toast.error(e?.response?.data?.message);
            else
                console.error(e)
        } finally {
            setLoadTable(false)
        }
    }

    // formatação

    const formatDate = (dateIso) => {
        return format(new Date(dateIso), 'dd/MM/yyyy HH:mm');
    }

    const formatDocument = (cpf_cnpj) => {
        return mask(unmask(cpf_cnpj), ['999.999.999-99', '99.999.999/9999-99'])
    }

    const formatPhone = (telefone) => {
        return mask(unmask(telefone), '(99) 99999-9999')
    }

    const mergeArrayString = (array, type) => {
        let mergedString = ''
        for (let stringItem of array) {
            let formatted = stringItem

            if (type === 'telefone') formatted = formatPhone(stringItem);

            mergedString = mergedString.length ? mergedString + ' \r\n/ ' + formatted : formatted;
        }
        return mergedString;
    }

    // action

    function filterSearch(key) {
        if (key === 13) {
            setPaginationData({ ...paginationData, page: 0, first: 0, });
            buscaHigienizados()
        }
    }

    function onPage(event) {
        setPaginationData(prev => ({
            ...prev,
            first: parseInt(event.first),
            rows: event.rows,
            page: event.page,
        }))
    }

    function changeType(value) {
        setSearchValue('');
        setSearchType(value)
    }

    // template

    const dropdownOptions = [
        { label: 'Documento', value: 'documento' },
        { label: 'Nome', value: 'nome' },
    ]

    const clipText = (text) => {
        return navigator.clipboard.writeText(text);
    }

    const headerMain = () => {
        return (
            <header className="w-full flex flex-col gap-5">
                <section className="w-full flex lg:flex-row flex-col justify-between">
                    <div className="w-full flex flex-row gap-2 h-[3rem]">
                        <span className="flex text-xl items-center">
                            Dados Devedores
                        </span>
                        <Button
                            icon={<FaFileExcel className='text-xl text-white dark:text-black' />}
                            pt={{
                                root: `hover:dark:bg-emerald-300 hover:bg-green-600 
                                dark:bg-emerald-400 bg-green-500 py-1 px-[0.675rem] my-1 rounded-lg
                                text-white dark:text-black`,
                                label: "absolute",
                            }}
                            onClick={() => downloadXLSX()}
                        />
                    </div>
                    <div className="w-full lg:w-fit flex sm:flex-row flex-col gap-2 sm:h-[3rem] lg:mt-3 sm:mt-5 sm:justify-end items-center ">
                        <span className="sm:w-56 w-full">
                            <Dropdown
                                value={searchType}
                                options={dropdownOptions}
                                pt={DropdownPague}
                                onChange={(e) => changeType(e.value)}
                            />
                        </span>
                        {searchType === 'documento' &&
                            <span className="sm:w-56 w-full sm:mt-0 mt-4">
                                <FloatLabel>
                                    <InputText
                                        value={searchValue}
                                        className="w-full"
                                        id="documento"
                                        onChange={(e) => { setSearchValue(formatDocument(e.target.value)) }}
                                        onKeyDown={(e) => filterSearch(e.keyCode)}
                                    />
                                    <label htmlFor="documento">CPF/CNPJ</label>
                                </FloatLabel>
                            </span>}
                        {searchType === 'nome' &&
                            <span className="sm:w-56 w-full sm:mt-0 mt-4">
                                <FloatLabel>
                                    <InputText
                                        value={searchValue}
                                        className="w-full"
                                        id="nome"
                                        onChange={(e) => { setSearchValue(e.target.value) }}
                                        onKeyDown={(e) => filterSearch(e.keyCode)}
                                    />
                                    <label htmlFor="nome">Nome</label>
                                </FloatLabel>
                            </span>}
                        <Button
                            pt={{
                                root: `hover:dark:bg-green-500 hover:bg-green-600 
                                          dark:bg-green-400 bg-green-500 
                                          p-3 rounded-full
                                          flex justify-center items-center
                                          h-[3rem] w-[3rem]
                                          text-white dark:text-black transition duration-300`,
                                label: "absolute",
                            }}
                            icon={<FaSearch className='text-xl' />}
                            onClick={() => filterSearch(13)}
                        />
                    </div>
                </section>
            </header>
        )
    }
    const renderHeaderMain = headerMain();

    const templateColumns = [
        { header: 'Info.', expander: true },
        { field: 'devedor_documento', header: 'CPF/CNPJ', body: (rowData) => formatDocument(rowData.devedor_documento) },
        { field: 'devedor_nome', header: 'Nome' },
        { field: 'devedor_sexo', header: 'Sexo', bodyStyle: { width: '8rem' } },
        { field: 'devedor_nascimento', header: 'Nascimento/Criação', bodyStyle: { width: '12rem' } },
        { field: 'data_higienizacao', header: 'Atualizado em', body: (rowData) => formatDate(rowData.data_higienizacao) },
    ]

    const rowExpansionTemplate = (data) => {
        const emails_arr = data.emails;
        const telefones_arr = data.telefones;
        const enderecos_arr = data.enderecos;

        return (
            <div className="w-full flex xl:flex-row xl:flex-nowrap flex-wrap gap-1">
                <DataView
                    header={<div className="w-[5rem]">Telefones</div>}
                    layout={'list'}
                    pt={
                        {
                            root: { className: 'flex grow-[1] w-fit rounded-lg overflow-hidden' },
                            content: { className: 'max-h-[8rem] lg:min-w-[12rem] w-full overflow-y-scroll bg-white blue-gray-700 border-0 p-0 dark:bg-gray-900 dark:text-white/80' },
                            header: { className: 'flex items-center  bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white/80 border-gray-200 dark:border-blue-900/40 border-t border-b p-4 font-bold' }
                        }
                    }
                    value={telefones_arr}
                    listTemplate={listTemplate}
                />
                <DataView
                    header={<div className="w-[5rem]">E-mails</div>}
                    layout={'list'}
                    pt={
                        {
                            root: { className: 'flex grow-[5] lg:w-fit w-full rounded-lg overflow-hidden' },
                            content: { className: 'lg:max-h-[8rem] max-h-[100%] overflow-y-scroll w-full bg-white blue-gray-700 border-0 p-0 dark:bg-gray-900 dark:text-white/80' },
                            header: { className: 'flex items-center  bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white/80 border-gray-200 dark:border-blue-900/40 border-t border-b p-4 font-bold' }
                        }
                    }
                    value={emails_arr}
                    listTemplate={listTemplate}
                />
                <DataView
                    header={<div className="w-[5rem]">Endereços</div>}
                    layout={'list'}
                    pt={
                        {
                            root: { className: 'flex grow-[1] xl:w-[50%] w-full rounded-lg overflow-hidden' },
                            content: { className: 'overflow-y-scroll w-full xl:max-h-[8rem] max-h-[100%] bg-white blue-gray-700 border-0 p-0 dark:bg-gray-900 dark:text-white/80 text-sm' },
                            header: { className: 'flex items-center bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white/80 border-gray-200 dark:border-blue-900/40 border-t border-b p-4 font-bold' }
                        }
                    }
                    value={enderecos_arr}
                    listTemplate={listTemplate}
                />
            </div>
        );
    };

    const listTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((product, index) => {
            return itemTemplate(product, index);
        });

        return <div className="grid grid-flow-row h-full">{list}</div>;
    };

    const itemTemplate = (item) => {
        let texto = item.length === 11 ? formatPhone(item) : item

        return (
            <div className={classNames(
                "w-full grid cursor-pointer items-center ",
                "dark:hover:bg-slate-700 hover:bg-slate-300 p-2",
                {
                    '!min-w-[9rem] text-left': item.replace(/\D/g, '').length === 11,
                    '!min-w-[20rem] text-left': item.includes('@'),
                },
            )}
                onClick={() => { clipText(texto); toast.info(`Informação copiada!`) }}
            >
                {texto}
            </div>
        );
    };

    return !viewHigienizadosStatus ?
        (
            <div className="flex justify-center">
                <AppCard>
                    <p>Você não possui o serviço de banco de dados</p>
                    <p>Contate esse número e ative o serviço.</p>
                    <a className="flex justify-center mt-2 flex-order-1 gap-2" href="https://wa.me/5511996383405" rel="noopener noreferrer" target="_blank">
                        <FaPhoneAlt className='text-xl' />
                        <div className="text-sm">
                            (11) 99638-3405
                        </div>
                    </a>
                    <div className="w-full flex justify-center mt-3">
                        <Link to="/dashboard">
                            <Button label="Voltar" />
                        </Link>
                    </div>
                </AppCard>
            </div>
        ) :
        (
            <div className="w-full">
                <AppCard className='!p-0 w-full'>
                    <div className="w-full overflow-x-scroll">
                        <DataTable
                            header={renderHeaderMain}
                            value={higienizados}
                            loading={loadTable}
                            pt={DataTablePague}
                            rowExpansionTemplate={rowExpansionTemplate}
                            expandedRows={expandedRows}
                            onRowToggle={(e) => setExpandedRows(e.data)}

                            first={paginationData.first}
                            rows={paginationData.rows}
                            rowsPerPageOptions={paginationData.rowsPerPage}
                            totalRecords={paginationData.totalRecords}
                            onPage={onPage}
                            paginator

                            lazy
                        >
                            {templateColumns.map((col) => (
                                <Column
                                    key={col.field}
                                    expander={col.expander}
                                    header={col.header}
                                    field={col.field}
                                    style={col.bodyStyle}
                                    body={col.body}
                                />
                            ))}
                        </DataTable>
                    </div>
                </AppCard>
            </div>
        )
} 